import graphql__045b4cf7794b3b3d80e7 from "./__generated__/PageSectionSitemap_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";

import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import SitemapManager from "../Sitemap/SitemapManager";

const PageSectionSitemap = props => {
  const pageSection = useFragment(PageSectionSitemap_pageSection, props.pageSection);
  const { title, description, iconClass } = pageSection;

  return (
    <PageSectionBlockWithTitleAndDescription
      title={title}
      description={description}
      iconClassName={iconClass}
      className="container box"
    >
      <SitemapManager />
    </PageSectionBlockWithTitleAndDescription>
  );
};

const PageSectionSitemap_pageSection = graphql__045b4cf7794b3b3d80e7;

export default PageSectionSitemap;
